var _path, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraduation = function SvgGraduation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    fill: "none",
    viewBox: "0 0 19 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.2 7.6V11c0 1.21-2.33 2.2-5.2 2.2s-5.2-.98-5.2-2.2V7.6",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.84 2.22a3.23 3.23 0 0 1 2.32 0l6.36 2.86c.64.29.64.76 0 1.04l-6.36 2.86c-.64.3-1.68.3-2.32 0L1.48 6.12c-.64-.29-.64-.76 0-1.04l6.36-2.86Z",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M17.5 9.5s-1-2-.5-3.5c.16-.47-7.5-.5-7.5-.5",
    vectorEffect: "non-scaling-stroke"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 5.5,
    fill: "currentColor",
    rx: 1.5,
    ry: 1
  })));
};
export default SvgGraduation;